// TODO: some codes are temporary hardcoded based on given data, maybe refactor later.
/* eslint-disable */
import React, { useState } from 'react'
import Uploader from "modules/common/components/Uploader";
import DragAndDrop from "modules/common/components/DragAndDrop";
import Img from "modules/common/components/Img";
import MiniLoader from "modules/common/components/MiniLoader";
import defaultPhoto from "assets/img/image-placeholder.jpg";
import _ from 'lodash';

const CitizenUploadRequirements = ({
  isLoading=false,
  formData, 
  setFormData,
  onChange,
}) => {
  const [activeRequirements, setActiveRequirements] = useState("id_url");

  const onClearPhoto = (key) => {
    setFormData({
      ...formData,
      [key]: ""
    })
  };

  if (isLoading) {
    return (
      <>
        <div className='row'>
          <div className='col-12'>
            <MiniLoader />
          </div>
        </div>
      </>
    );  
  }

  const getUploadREquirementsErrorMsg = (type) => {
    if (!_.get(formData, `${type}`, "")) {
      return <span className={`animated fadeIn  fas fa-times ${activeRequirements === type ? "text-white" : "text-danger"}`} style={{ fontSize: 16, padding: "1px" }}/>
    }
    return <span className='animated fadeIn fa fa-check text-success' style={{ fontSize: 16, padding: "1px" }} />
  }

  return (
    <>
    <span className="font-italic mr-2" style={{ fontSize: "12px "}}>
      (Please upload necessary requirements) {(!_.get(formData, "id_url") || !_.get(formData, "photo")) && <small className="ml-1 text-danger">required</small>}
    </span>
     <div className='row my-1'>
      <div className='col-12 col-md-4 requirements-list'>
        <div className=''>
          {/* left button side */}
          <div
            role='presentation'
            className={`arrow-cell px-3 btn-blank rounded ${activeRequirements === "id_url" ? 'active text-white cms-outline-primary cms-bg-color-primary' : ''}`}
            // className="arrow-cell px-3 btn-blank rounded text-white active cms-outline-primary cms-bg-color-primary"
            style={{ clipPath: 'polygon(0% 0%, 95% 0px, 100% 50%, 95% 100%, 0% 100%)', marginRight: '-13px' }}
            onClick={() => setActiveRequirements("id_url")}
          >
            <div className='w-100 font-weight-bold py-3 d-flex justify-content-between align-items-center'>
              Valid ID 
              {getUploadREquirementsErrorMsg("id_url")}
            </div>
          </div>
          <div
            role='presentation'
            className={`arrow-cell px-3 btn-blank rounded ${activeRequirements === "photo" ? 'active text-white cms-outline-primary cms-bg-color-primary' : ''}`}
            style={{ clipPath: 'polygon(0% 0%, 95% 0px, 100% 50%, 95% 100%, 0% 100%)', marginRight: '-13px', border: "none" }}
            onClick={() => setActiveRequirements("photo")}
          >
            <div className='w-100 font-weight-bold py-3 d-flex justify-content-between align-items-center'>
              Photo
              {getUploadREquirementsErrorMsg("photo")}
            </div>
          </div>
        </div>
      </div>
      {/* right panel */}
      <div className='col-12 col-md-8'>
        <div className='form-wrapper arrow-card p-2 rounded cms-outline-primary border-0'>
          <UploadRequirements
            type={activeRequirements}
            onChange={onChange}
            onClearPhoto={onClearPhoto}
            formData={formData}
            setFormData={setFormData}  
          />
        </div>  
      </div>
     </div>
    </>
  )
}

const UploadRequirements = ({ type, onChange, formData, onClearPhoto }) => {
  if (!_.get(formData, `${type}`, "")) {
    return (
      <DragAndDrop
        onChange={onChange(type)}
        maxSize={5}
        caption='JPEG. PNG. Maximum size 5MB.'
        label="Upload your Requirements here"
        fileType='image/jpeg, image/jpg, image/png'
        isRequired
      />
    )
  }
  
  return (
    <>
      <div
        className='text-center d-flex align-items-center flex-column pb-5'
        style={{ borderTopRightRadius: '10px', borderTopLeftRadius: '10px', boxShadow: '2px 2px 12px #00000014', backgroundColor: '#F2F7FF'}}
      >
        <div className='d-flex justify-content-end w-100 container mt-2'>
          <button
            type="button"
            className="btn btn-sm btn-light p-1 m-2 rounded w-sm-100"
            onClick={() => onClearPhoto(type)}
          >
            <i className='fas fa-times-circle text-dark mr-1' />
            Clear Photo
          </button>
          <Uploader
            className='btn btn-sm btn-primary p-1 m-2 rounded w-sm-100'
            icon={
              <>
                <i className='fas fas fa-pen mr-2'/>
                Re-Upload
              </>
            }
            onChange={onChange(type)}
            customLoading={<i className='fas fa-spinner fa-spin' />}
            style={{ height: 30 }}
          />
        </div>  
          <Img
            src={!_.isObject(_.get(formData, `${type}`, '') || '') ? 
              _.get(formData,`${type}`, '') || ImagePlaceholder : 
              _.get(formData, `${type}.cdnUrl`, '') || ImagePlaceholder
              }
            className='img-fluid shadow-lg m-2'
            role='presentation'
            defaultSrc={defaultPhoto}
            width='70%'
            alt=''
          />
      </div>
    </>
  )
}

export default CitizenUploadRequirements